import React, { useEffect, useState } from 'react';
import { Dialog } from '@mui/material';
import { Button, TextAreaInput, Typography } from '@leapeasy/ui-kit';
import styled from 'styled-components';

/**
 * Confirm accept or decline for incoming notification requests (prod From list).
 * @param {{ type: 'accept' | 'decline', open: boolean, onClose: () => void, onConfirm: (declineReason?: string) => void }} props
 */
export const NotificationRequestActionDialog = ({ type, open, onClose, onConfirm }) => {
  const [declineReason, setDeclineReason] = useState('');

  useEffect(() => {
    if (!open) setDeclineReason('');
  }, [open]);

  const isDecline = type === 'decline';
  const canConfirm = !isDecline || Boolean(declineReason?.trim());

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogBody>
        <Typography variant="h6" style={{ marginBottom: 16 }}>
          Are you sure you want to {isDecline ? 'decline' : 'accept'}?
        </Typography>
        {isDecline && (
          <>
            <Typography variant="body2" style={{ marginBottom: 8 }}>
              Write your decline reason.
            </Typography>
            <TextAreaInput
              value={declineReason}
              onChange={(e) => setDeclineReason(e.target.value)}
              fullWidth
              placeholder="Decline reason"
            />
          </>
        )}
        <Actions>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={!canConfirm}
            onClick={() => onConfirm(isDecline ? declineReason.trim() : undefined)}
          >
            OK
          </Button>
        </Actions>
      </DialogBody>
    </Dialog>
  );
};

const DialogBody = styled.div`
  padding: 24px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
`;
